import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[color:var(--neon-purple)] group-[.toaster]:text-white group-[.toaster]:border-[color:rgba(242,210,60,0.4)] group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-white/70",
          actionButton:
            "group-[.toast]:bg-[color:var(--neon-gold)] group-[.toast]:text-[#111827]",
          cancelButton:
            "group-[.toast]:bg-transparent group-[.toast]:text-white/70 group-[.toast]:border group-[.toast]:border-white/20",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
